import type { MockBranchReviewReport } from '@readme/iso';

import React, { useEffect } from 'react';

import useReadmeApi from '@core/hooks/useReadmeApi';
import type { APIErrorType } from '@core/types';

import { useSuperHubStore } from '..';

export function InitializeReviewReport({ children }: { children: React.ReactNode }) {
  const [apiBaseUrl, currentBranch, isReviewReportReady, updateReviewReport, isReviewActionsEnabled] = useSuperHubStore(
    s => [
      s.getApiBaseUrl(),
      s.getCurrentChildBranch(),
      s.branches.reviewReport?.status === 'completed' || s.branches.reviewReport?.status === 'failed',
      s.branches.updateReviewReport,
      s.isSuperHubBranchReviewActionsEnabled,
    ],
  );

  const isCurrentBranchReviewReady = currentBranch?.review_status?.status === 'ready';
  const url = isReviewActionsEnabled && isCurrentBranchReviewReady ? '/review/report' : null;
  const { data } = useReadmeApi<{ data: MockBranchReviewReport }, APIErrorType>(url, {
    apiBaseUrl,
    swr: {
      // Poll endpoint every X seconds until report is ready.
      refreshInterval: isReviewReportReady ? 0 : 5000,
      revalidateOnFocus: false,
      shouldRetryOnError: false,
    },
  });

  useEffect(() => {
    if (!data) return;
    updateReviewReport(data.data);
  }, [data, updateReviewReport]);

  return <>{children}</>;
}
